import { useState } from 'react';
import { motion } from "framer-motion";
import Button from '../../components/Button';
import Form from '../../components/Form';
import './steps.scss';
import getProfileData from '../../services/initial-record/profile';
import { isEmpty } from '../../utils/helpers';

import Select from 'react-select'
import { useToast } from '../../hooks/toast';
import { VERSION } from '../../config/config';
import { SelectSearch } from '../../components/select/select';
import { provinces } from '../../utils/provinces';
import { maxPhoneNumber, 
    maxPrefixPhone
 } from '../../utils/const';

const countryTelData = require("country-telephone-data");

export default function Step1(props) {
    const { step, setStep, token, document_types, step1Data, setstep1Data, x, setX, loadingDocumentList, setLoadingDocumentList, disabledDocumentList, errorDocumentList } = props;
    const [document_type_select, setDocumentTypeSelect] = useState({ value: step1Data.document_type || '', label: step1Data.document_type || 'Seleccione un tipo de documento' });
    step1Data.country_code = '54';
    const { notify: message } = useToast();
    const [validate, setValidate] = useState(false);
    const [showSelect,setShowSelect] = useState(false);

    const handleInputChange = ({ target }) => {
        const { name, value } = target;
        setstep1Data({
            ...step1Data,
            [name]: value,
        });
        validateForm();
    }

    const validateForm = () => {
        let validated = true;
        let keys = Object.keys(step1Data);
        for (let i = 0; i < keys.length; i++) {
            if (isEmpty(step1Data[keys[i]])) {
                validated = false;
            }
        }
        setValidate(validated);
    }

    const handleDocumentNumberChange = ({ target }) => {
        handleInputChange({ target });
        const { value } = target;
        if (value.length > 6) {
            const params = {
                tipodocu: document_type_select.value,
                ndocu: value
            }
            // setLoadingDocumentList(true);
            // getProfileData({
            //     token, params, callbacks: (response) => {
            //         setLoadingDocumentList(false);
            //         if (response.success) {
                        
            //             response = response.data;
            //             if (response.tdocu) {
            //                 const user = {
            //                     document_type: response.tdocu,
            //                     document_number: response.ndocu,
            //                     name: response.nombre,
            //                     surname: response.apellido,
            //                     email: response.email,
            //                     // whatsapp_prefix: response.codTelefono,
            //                     // whatsapp_number: response.telefono
            //                 }
            //                 setstep1Data(user);
            //             }
            //             else {
            //                 const user = {
            //                     document_type: document_type_select.value,
            //                     document_number: value,
            //                     name: '',
            //                     surname: '',
            //                     email: '',
            //                     // whatsapp_prefix: '',
            //                     // whatsapp_number: ''
            //                 }
            //                 setstep1Data(user);
            //             }
            //             validateForm();
            //         }
            //     }
            // });
        }
    }

    const handleSelectChange = (selected) => {
        setstep1Data({
            ...step1Data,
            document_type: selected.value,
        })
        setDocumentTypeSelect(selected);
    }

    function changeStep(e) {
        e.preventDefault();
        let run = true;
        let response = [];
        if (isEmpty(step1Data.document_number)) {
            run = false;
            response.push('Debes indicar el numero de documento')
        }
        if (isEmpty(step1Data.name)) {
            run = false;
            response.push('Debes indicar tu nombre completo')
        }
        if (isEmpty(step1Data.surname)) {
            run = false;
            response.push('Debes indicar tu apellido')
        }
        if (isEmpty(step1Data.email)) {
            run = false;
            response.push('Debes indicar un email')
        } else {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(step1Data.email)) {
                run = false;
                response.push('El formato del email no es válido');
            }
        }
        if (isEmpty(step1Data.whatsapp_prefix)) {
            run = false;
            response.push('Debes indicar el prefijo de telefono')
        }
        if (isEmpty(step1Data.whatsapp_number)) {
            run = false;
            response.push('Debes indicar el numero de telefono')
        }

        if (isEmpty(step1Data.country_code)) {
            // en caso de no indicar código de país en vez de tirar error se le asigna el código de Argentina por defecto
            step1Data.country_code = '54';
            //run = false;
            //response.push('Debes indicar el prefijo pais')
        }

        if (run) {
            setStep(step + 1);
            setX(1000);
        } else {
            const error = {
                success: false,
                error: { errors: response }
            };
            message(error);
        }
    }

    const handleChangeCountryCode = (selected) => {
        setstep1Data({
          ...step1Data,
          country_code: selected?.value,
          whatsapp_prefix: (selected?.value != 54 ) ? step1Data.whatsapp_prefix : '',
        });
        setShowSelect(selected?.value ==54 )
      };
      
    const handleChangeWhatsappPrefix = (selected) => {
        setstep1Data({
          ...step1Data,
          whatsapp_prefix: selected?.value,
        });
      };

    return (
        <motion.div
            initial={{ x: x }}
            transition={{ duration: 0.5 }}
            animate={{ x: 0 }}
        >
            <div className='box'>
                <Form className='form-flex'>
                    <div className="box-header">
                        <span className="step-numer">{step + 1}</span>
                        <h2>Completá tus datos personales</h2>
                    </div>
                    <div className="box-body">
                        <div className="d-flex my-1">
                            <Select
                                className='width-100'
                                options={document_types}
                                defaultValue={document_type_select}
                                onChange={handleSelectChange}
                                placeholder={!isEmpty(errorDocumentList) ? `Seleccione un tipo de documento` : errorDocumentList}
                                noOptionsMessage={() => 'No hay opciones'}
                                isLoading={loadingDocumentList}
                                isDisabled={disabledDocumentList}
                            />
                        </div>
                        <div className="d-flex my-1">
                            <input type="text" placeholder={`Mi Nro de ${document_type_select.value || 'DNI'} es...`} name="document_number" id="document_number" value={step1Data.document_number || ''} onChange={handleDocumentNumberChange} className={`${isEmpty(document_type_select.value) ? 'disabled' : 'enabled'}`} disabled={isEmpty(document_type_select.value)} />
                        </div>
                        <div className="d-flex my-1">
                            <input type="text" placeholder="Mi nombre completo es..." name="name" id="name" value={step1Data.name || ''} onChange={handleInputChange} className={`${isEmpty(document_type_select.value) ? 'disabled' : 'enabled'}`} disabled={isEmpty(document_type_select.value)} />
                        </div>
                        <div className="d-flex my-1">
                            <input type="text" placeholder="Mi apellido completo es..." name="surname" id="surname" value={step1Data.surname || ''} onChange={handleInputChange} className={`${isEmpty(document_type_select.value) ? 'disabled' : 'enabled'}`} disabled={isEmpty(document_type_select.value)} />
                        </div>
                        <div className="d-flex my-1">
                            <input type="email" placeholder="Mi email es..." name="email" id="email" value={step1Data.email || ''} onChange={handleInputChange} className={`${isEmpty(document_type_select.value) ? 'disabled' : 'enabled'}`} disabled={isEmpty(document_type_select.value)} />
                        </div>
                        <div className="d-flex my-1">
                            <div className="w-25 mr-05">
                                <SelectSearch
                                placeholder="prefijo"
                                defaultValue={step1Data.country_code ?? '54'}
                                value={step1Data.country_code ?? '54'}
                                disabled={isEmpty(document_type_select.value)}
                                options={countryTelData.allCountries?.map((dt) => {
                                    return {
                                    value: dt.dialCode,
                                    label: `${dt.name} (+${dt.dialCode})`,
                                    };
                                })}
                                changed={(option) => {
                                    handleChangeCountryCode(option);
                                }}
                                />
                            </div>
                            <div className="w-25 mr-05 ml-05">
                                {showSelect ? 
                                    <SelectSearch
                                        placeholder="area"
                                        defaultValue={step1Data.whatsapp_prefix}
                                        disabled={isEmpty(document_type_select.value)}
                                        options={provinces}
                                        changed={(option) => {
                                            handleChangeWhatsappPrefix(option);
                                        }}
                                        />
                                    :
                                    <>
                                        <input 
                                        type="number" placeholder="area" name="whatsapp_prefix" id="whatsapp_prefix" 
                                        value={step1Data.whatsapp_prefix || ''}  
                                        className={`w-9 ${isEmpty(document_type_select.value) ? 'disabled' : 'enabled'}`} 
                                        disabled={isEmpty(document_type_select.value)}  
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '').slice(0, maxPrefixPhone); 
                                            const length =`${e.target.value}`.length
                                            if((value || e.target.value =='' ) && length < maxPrefixPhone){
                                                handleInputChange(e)
                                            }
                                          }}
                                        onKeyDown={(e) => {
                                            const invalidKeys = ['e', 'E', '+', '-', '.', ','];
                                            if (invalidKeys.includes(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                    </>
                                }
                            </div>
                            
                            <input type="number" placeholder="Whatsapp" name="whatsapp_number" id="whatsapp_number" value={step1Data.whatsapp_number || ''}  
                            className={`w-full mr-05 ${isEmpty(document_type_select.value) ? 'disabled' : 'enabled'}`} disabled={isEmpty(document_type_select.value)} 
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '').slice(0, maxPhoneNumber); 
                                const length =`${e.target.value}`.length
                                if((value || e.target.value =='' ) && length<maxPhoneNumber){
                                    handleInputChange(e)
                                }
                              }}
                            onKeyDown={(e) => {
                                const invalidKeys = ['e', 'E', '+', '-', '.', ','];
                                if (invalidKeys.includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                        </div>
                    </div>
                    <div className="box-footer btn-group">
                        <Button type="submit" className='btn-step' onClick={changeStep} disabled={isEmpty(document_type_select.value) && !validate} >Siguiente</Button>
                    </div>
                    <span className='version'>{VERSION}</span>
                </Form>
            </div>
        </motion.div>
    )
}